import React, { useState } from 'react'
import get from 'lodash/get'
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined'
import Box from '@material-ui/core/Box'

import { ArchiveScenarioModal } from '@components/Modal/ArchiveScenarioModal'

export const ArchiveButton = ({ retirementScenario, scenarioPath, dashboardPath }) => {
  const [archiving, setArchiving] = useState(false)
  return (
    <>
      <ArchiveScenarioModal
        open={archiving}
        close={() => setArchiving(false)}
        scenarioName={get(retirementScenario, 'name')}
        scenarioPath={scenarioPath}
        dashboardPath={dashboardPath}
      />
      <Box
        className='nav-items__item__archive-button'
        display='flex'
        justifyContent='center'
        alignItems='center'
        color='white'
      >
        <ArchiveOutlinedIcon
          style={{ color: 'white', cursor: 'pointer' }}
          fontSize='small'
          onClick={() => setArchiving(true)} />
      </Box>
    </>
  )
}
